import React from 'react';
import Title from 'common/Title';
import ConnectionsListPlaceholder from '../home/connections/ConnectionsListPlaceholder';
import ServicesPanelPlaceholder from '../home/services/ServicesPanelPlaceholder';

export default class ResultsPlaceholder extends React.Component {
  render() {
    return (
      <div>
          <ServicesPanelPlaceholder title="Services" />
          <div>
            <Title text="People" />
            <ConnectionsListPlaceholder />
          </div>
      </div>
    );
  }
}
